export default "__VITE_ASSET__eb89c131__"